import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { makeBoilerPlateTandCsLive } from "./actions";

const MakeBoilerPlateLiveModal = ({
  id,
  dealerId,
  onSubmitted,
  reference,
  ...props
}) => {
  return (
    <ModalBuilder
      submitAction={makeBoilerPlateTandCsLive}
      submitParams={{ id, dealerId }}
      onSubmitted={onSubmitted}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Live
        </div>
      )}
      renderModal={(modalProps) => (
        <Modal.Confirmation {...modalProps} header={"Make Live: " + reference}>
          {reference + ": Make Master Agreement Terms Live?"}
        </Modal.Confirmation>
      )}
    />
  );
};

export default MakeBoilerPlateLiveModal;
